// vef-internal
import { CDN } from "../../CDN.js";
import { SidebarElement } from "../../ui/sidebar/SidebarElement.js";
import "./DASFForm.css";

/**
 * Form for creating requests to a DASF (Data Analytics Software Framework) backend
 * @memberof vef.data.dasf
 */
export class DASFForm extends SidebarElement {

    /**
     * @param {HTMLElement} target 
     * @param {object} options {"schema": {}}
     */
    constructor(target, options) {
        super(target, {
            "submit": [],
            "invalid": []
        });

        this.options_ = Object.assign({}, options || {});

        this.setClass("dasf-form");
        this.setTitle(this.options_.title || "DASF Importer");
        this.initForm_();
    }

    /**
     * @override
     */
    dispose() {
        if (this.editor_) this.editor_.destroy();
    }

    /**
     * @private
     */
    initForm_() {
        CDN.import("JSONEditor").then(Editor => {
            const form = document.createElement("div");

            this.editor_ = new Editor(form, {
                theme: 'bootstrap4',
                schema: this.options_.schema,
                disable_edit_json: true,
                disable_collapse: true,
                disable_properties: true,
                titleHidden: true
            });

            this.editor_.on('ready', () => {
                const submitButton = document.createElement("button");
                submitButton.innerText = "Submit";
                form.appendChild(submitButton);
                submitButton.addEventListener("click", e => {
                    const errors = this.editor_.validate();
                    if (errors.length) {
                        this.fire("invalid", errors);
                    }
                    else {
                        this.fire("submit", this.editor_.getValue());
                    }
                })

            });

            this.setContent(form);
        });
    }

}